import React, { useState } from 'react';
import { Link2, Pencil, Plus, Trash2 } from 'lucide-react';
import { entryPhotoStrings as strings } from '../../content/entryPhotos';
import { emptyAlbumDraft, validateAlbumDraft } from './albumDraft';

/** Collects a provider album link before a Trip or Hike has an entry ID. */
export default function EntryPhotoAlbumDraftPicker({ draft, onChange, hobbyId }) {
  const [editing, setEditing] = useState(false);
  const [working, setWorking] = useState(emptyAlbumDraft);
  const hasDraft = Boolean(draft.label.trim() || draft.url.trim());

  const open = () => {
    setWorking({ ...draft });
    setEditing(true);
  };
  return <div className="entry-album-draft">
    <div className="photo-albums-heading">
      <h3>{strings.albums}</h3>
      <button type="button" className="photo-albums-icon-button" title={hasDraft ? strings.editAlbum : strings.addAlbumLink} aria-label={hasDraft ? strings.editAlbum : strings.addAlbumLink} onClick={open}>{hasDraft ? <Pencil size={18} /> : <Plus size={18} />}</button>
      {hasDraft && <button type="button" className="photo-albums-icon-button danger" title={strings.removeAlbum} aria-label={strings.removeAlbum} onClick={() => onChange(emptyAlbumDraft)}><Trash2 size={18} /></button>}
    </div>
    {hasDraft ? <div className="photo-album-row"><Link2 size={18} /><strong>{draft.label}</strong></div> : <p className="detail-notes">{strings.emptyAlbums}</p>}
    {editing && <div className="photo-album-form">
      <label>{strings.albumName}<input maxLength={80} value={working.label} onChange={(event) => setWorking({ ...working, label: event.target.value })} /></label>
      <label>{strings.albumLink}<input type="url" value={working.url} onChange={(event) => setWorking({ ...working, url: event.target.value })} placeholder="https://" /></label>
      {hobbyId === 'traveling' && <label className="photo-album-check"><input type="checkbox" checked={working.visibility === 'shared'} onChange={(event) => setWorking({ ...working, visibility: event.target.checked ? 'shared' : 'owner' })} />{strings.sharedAlbum}</label>}
      <small className="photo-storage-usage">{strings.albumStorageNote}</small>
      <div className="photo-album-actions">
        <button type="button" className="btn-ghost" onClick={() => setEditing(false)}>Cancel</button>
        <button type="button" className="btn-primary" disabled={!working.label.trim() || !validateAlbumDraft(working)} onClick={() => { onChange(working); setEditing(false); }}>{strings.saveAlbum}</button>
      </div>
    </div>}
  </div>;
}
